$(function () {
    let _private = {};
    _private.cardStyles = ['NM', 'EX', 'VG', 'G'];
    window.ckCatalog = window.ckCatalog || {};
    /* set displayed style */
    $(document).on('touchend click', '.cardTypeList > li:not(.active)', function () {
        let activeStyle = _.intersection(this.classList, _private.cardStyles);
        if (activeStyle.length > 0) {
            activeStyle = '.' + activeStyle[0];
        }
        let $parent = $(this).parent();
        let $cartTileList = $parent.siblings('.addToCartByType');
        $cartTileList.find('.active').removeClass('active');
        $cartTileList.find(activeStyle).addClass('active');
        $parent.find('li.active').removeClass('active');
        $parent.find(activeStyle).addClass('active');
    });

    /* highlight selected qty in addToCart widget */
    $(document).on('show.bs.dropdown', '.addToCartForm .dropdown', function (event) {
        let $form = $(event.relatedTarget).parents('.addToCartForm');
        let currentQty = parseInt($form.find('input[name=qty]').val());
        $form.find('.picked').removeClass('picked');
        if(currentQty >= 0) {
            let newQtySelector = 'li:nth-child(' + (currentQty + 1) + ')';
            $form.find(newQtySelector).addClass('picked');
        }
    });

    $(document).on('touchend click', '.addToCartForm .qtyList > li', function (e) {
        let _count = parseInt($(this).text());
        if (isNaN(_count)) {
            _count = 0;
        }
        _private.updateSelectedQty(this, _count);
    });

    $(document).on('click', '.addToCartForm:not(.maxxed) .addOneButton, .addToCartForm:not(.maxxed) .addItemToCart', function () {
        let newQty = parseInt($(this).parents('form').find('.qty').val()) || 0;
        newQty++;
        _private.updateSelectedQty(this, newQty);
    });

    $(document).on('click',  '.addToCartFormBulk .addItemToCartBulk', function () {
        _private.processBulkInput(this);
    });

    $(document).on('keydown', '.addToCartFormBulk .qty', function(event){
        if(event.keyCode == 13) {
            event.preventDefault();
            _private.processBulkInput(this);
        }
    });

    _private.processBulkInput = function(target) {
        let newQty = parseInt($(target).parents('form').find('.qty').val()) || 0;
        let maxQty =  parseInt($(target).parents('form').find('.maxQty').val()) || 0;
        $(target).parents('form').find('.warning').remove();
        if(newQty > maxQty){
            let htmlWarning = '<div class="warning">Max quantity is '+ maxQty +'.</div>';
            $(target).parents('form').append(htmlWarning);
        } else {
            _private.updateSelectedQty(target, newQty);
        }
    };

    $(document).on('click', '.removeAll', function () {
        _private.updateSelectedQty(this, 0);
    });

    /* update addToCart forms based on cart */
    $(document).on('cartUpdated.ck', function (evt) {
        let cartData = window.ckCatalog.cart();
        let cart = cartData.items;
        _private.populateFormQty(cartData);
        Object.keys(cart).forEach(function (key) {
            let selector = '.' + key;
            if ($(selector).length > 0) {
                let qty = cart[key].qty || 0;
                let maxQty = parseInt($(selector).find('input[name=maxQty]').val());
                $(selector).find('input[name=qty]').val(qty);
                if (qty >= maxQty) {
                    $(selector).addClass('maxxed');
                }
            }
        });
    });

    _private.cartSet = _.debounce(function (data) {
        _private.submitUpdate(data);
    }, 500);

    _private.updateSelectedQty = function (context, newQty) {
        $(document).trigger('cartStartUpdate.ck');
        let $form = $(context).parents('form');
        let data = {};
        data.category = $form.find('input[name=category]').val();
        data.model = $form.find('input[name=model]').val();
        data.name = $form.find('input[name=name]').val();
        data.slug = $form.find('input[name=slug]').val();
        data.title = $form.find('input[name=title]').val();
        data.variation = $form.find('input[name=variation]').val() || '';
        data.currentCount = parseInt($form.find('.qty').val()) || 0;
        data.id = $form.find('.product_id').val();
        data.style = $form.find('.style').val();
        data.qty = parseInt(newQty || 0);
        data.mode = $('body').hasClass('purchasing') ? 'sell-cart' : '';
        let priceSale = $form.find('input[name=price_sale]').val() || '';
        data.price = (priceSale.length > 0) ? priceSale : $form.find('input[name=price]').val();

        data.callback = function (cart, newMaxQty) {
            if (typeof newMaxQty !== 'undefined') {
                // Clamp newMaxQty to >= 0
                newMaxQty = Math.max(0, newMaxQty);

                // Set the new max qty in the form, the cart add element, and remove any li's from the qtyList that exceed our new max
                let $parent = $form.parent();
                $form.find('.maxQty').val(newMaxQty);
                $form.find('.qty').val(newMaxQty);
                $parent.find('.styleQty').text(newMaxQty);
                $parent.find('.qtyList').children().filter(a => a > newMaxQty).remove();
            }

            let maxQty = parseInt($form.find('.maxQty').val()) || 0;
            $form.find('input[name=qty]').val(newQty);

            if (newQty >= maxQty) {
                $form.addClass('maxxed');
            }

            if (cart) {
                // If we have a valid cart to update, do so
                data.cart = cart;
                $(document).trigger('updateCart.ck', [data]);
            } else {
                // Fall back and update with the old cart
                $(document).trigger('cartUpdated.ck',[window.ckCatalog.cart()]);
            }
        };

        _private.cartSet(data);
    };

    _private.getReturnedQty = function (data, cart) {
        let cartIndex = _.findKey(cart, function (item) {
            return item.product_id == data.id && item.style == data.style
        });
        let cartItem = cart[cartIndex] || {};
        return parseInt(cartItem.qty || 0);
    };

    _private.submitUpdate = function (data) {
        let _self = this;
        let ack;
        let style = data.style || '';
        let qty = parseInt(data.qty);
        let uri = '';

        //is this a buy cart or a sell cart?
        let type = (data.mode === 'sellcart' || $('body').hasClass('purchasing')) ? 'sell-cart' : 'buy-cart';

        let params = {
            product_id: data.id,
            style: style,
            quantity: qty,
        };

        if (type === 'sell-cart') {
            uri = '/api/sellcart/add';
        } else {
            uri = '/api/cart/add';
        }

        _self.makeRequest(uri, 'POST', params).then(function (response) {
            try {
                ack = JSON.parse(response.responseText);
            } catch (e) {
                $(document).trigger('notify.ck', {
                    message: "There was a problem adding &quot;" + data.title + " - " + data.style + "&quot; to the cart. Please refresh the page, and try again.",
                    severity: "error"
                });
            }
            if (typeof data.callback == 'function') {
                data.callback(ack);
            }
        }, function (rejected) {
            let message = 'There was a problem adding &quot;' + data.title + ' - ' + data.style + '&quot; to the cart. Please refresh the page, and try again.';
            let severity = 'error';
            let newMaxQty;
            if (rejected && rejected.context && rejected.context.exception) {
                switch (rejected.context.exception) {
                    case 'MaxQuantityExceeded': {
                        let avail = rejected.context.available;
                        if (typeof avail !== 'undefined') {
                            newMaxQty = avail;
                            if (avail <= 0) {
                                avail = 0;
                            }
                            message = 'Couldn\'t add ' + qty + ' x &quot;' + data.name + '&quot; (' + data.style + ') to the cart; amount available has reduced to ' + avail + '.';
                        }
                        break;
                    }
                }
            }
            $(document).trigger('notify.ck', {
                message: message,
                severity: severity
            });
            if (typeof data.callback == 'function') {
                data.callback(undefined, newMaxQty);
            }
        })
    };

    _private.makeRequest = function (url, method, params) {

        // Create the XHR request
        var request = new XMLHttpRequest();

        // Return it as a Promise
        return new Promise(function (resolve, reject) {

            // Setup our listener to process completed requests
            request.onreadystatechange = function () {

                // Only run if the request is complete
                if (request.readyState !== 4) return;

                // Process the response
                if (request.status >= 200 && request.status < 300) {
                    // If successful
                    resolve(request);
                } else {
                    // Attempt to parse payload context, if present
                    let errorContext;

                    try {
                        errorContext = JSON.parse(request.responseText);
                    } catch (e) {
                        errorContext = null;
                    }

                    // If failed
                    reject({
                        status: request.status,
                        statusText: request.statusText,
                        context: errorContext
                    });
                }
            };

            // Setup our request
            request.open(method || 'GET', url, true);
            request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            request.setRequestHeader("Accept", "application/json;charset=UTF-8");
            // Send the request
            request.send(JSON.stringify(params));
        });
    };
    /* populateFormQty sets widget qty for items displayed, already added to cart */
    _private.populateFormQty = function(cartData){
        // If cartData.fullItems is specified, use it with priority; it implies something was removed that we'll need to clear out
        var cardData = cartData.hasOwnProperty('fullItems') && cartData.fullItems ? cartData.fullItems : cartData.items;
        var _html = '';
        $itemForms = $('.addToCartForm'); //select all displayed addToCart widgets

        for (let cartItemKey in cardData) {
            let cartItem = cardData[cartItemKey];
            $itemForms.each(function(key,value){
                if( cartItem.product_id == $(value).find('.product_id').val() &&  cartItem.style === $(value).find('.style').val() ) {
                    $(value).find('input[name=qty]').val( cartItem.qty);
                    if( parseInt(cartItem.qty) > 0) {
                        _text = '<span class="inCartDesc">'+ cartItem.qty +' in Cart</span>';
                        $(value).find('.removeAll').addClass('avail');

                    } else {
                        if( $('body').hasClass('purchasing')) {
                            _text = '<span>Qty to Sell</span>';
                        } else {
                            _text = '<span>Add to Cart</span>';
                        }
                        $(value).find('.removeAll').removeClass('avail');
                    }
                    $(value).find('.addToCartButton').html(_text);
                }

            });
        }

    };

});


